import { Outlet } from 'react-router-dom';
import Sidebar from '@components/dashboard/Sidebar';
import DashboardHeader from '@components/dashboard/DashboardHeader';
import ModalHost from '@components/common/ModalHost';
import ModalRegistry from '@components/common/modalRegistry/ModalRegistry';
import { OnboardingBanner } from '@components/dashboard/OnboardingBanner';
import { useAppSelector } from '@store/hooks';
import { cn } from '@utils/cn';
import { useOnboardingStatus } from '@/hooks/useOnboardingStatus';

const DashboardLayout = () => {
  const { sidebarOpen, sidebarHoverExpanded } = useAppSelector(state => state.ui);
  const onboardingStatus = useOnboardingStatus();

  return (
    <div className="h-screen bg-[#faf9f5] font-sans">
      <Sidebar onboardingStatus={onboardingStatus} />
      <div
        className={cn(
          'transition-[margin,padding] duration-300 flex flex-col h-full',
          sidebarOpen || sidebarHoverExpanded ? 'lg:ml-56' : 'lg:ml-20'
        )}
      >
        <div className="flex-shrink-0">
          <DashboardHeader />
        </div>
        <main className="flex-1 px-4 pt-0 pb-0 overflow-y-auto bg-white md:px-0 md:pt-0 md:pb-0">
          <OnboardingBanner status={onboardingStatus} />
          <Outlet />
        </main>
      </div>
      <ModalRegistry />
      <ModalHost />
    </div>
  );
};

export default DashboardLayout;
